<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">{{ $t(template.baseTitle) }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideBase"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <template v-if="base === 'A' || base === 'B'">
          <v-row>
            <v-col cols="12" class="col-md-4">
              <CommonDatePicker
                :label="itemLabel('baseBirthday')"
                v-model="birth"
                useMaxCurrentDate
                @change="save"
                :readonly="isReadonly"
                :rules="[rules.required('baseBirthday')]"
              />
            </v-col>
            <v-col cols="12" class="col-md-4" :class="colclass">
              <i-text-field
                :label="itemLabel('baseNameEn')"
                v-model="nameEn"
                outlined
                v-maxlength="'base_name_en'"
                hide-details="auto"
                dense
                :readonly="isReadonly"
                :rules="[
                  rules.required('baseNameEn'),
                  rules.maxlength('baseNameEn'),
                ]"
                @blur="save"
                :class="rightRoundedClass"
              ></i-text-field>
            </v-col>
            <v-col cols="12" class="col-md-4" :class="colclass">
              <v-col :class="radiocolclass">
                <v-radio-group
                  v-model="gender"
                  row
                  :rules="[
                    rules.required('baseGender'),
                    rules.maxlength('baseGender'),
                  ]"
                  :readonly="isReadonly"
                  hide-details="auto"
                  @change="save"
                >
                  <span class="col-4 py-0">{{ itemLabel('baseGender') }}</span>
                  <i-radio
                    label="남"
                    value="남"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                  <i-radio
                    label="여"
                    value="여"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                </v-radio-group>
              </v-col>
            </v-col>
          </v-row>
        </template>
        <template v-else-if="base === 'G' || base === 'H'">
          <v-row>
            <v-col cols="12" class="col-md-6">
              <CommonDatePicker
                :label="itemLabel('baseBirthday')"
                v-model="birth"
                useMaxCurrentDate
                @change="save"
                :readonly="isReadonly"
                :rules="[rules.required('baseBirthday')]"
              />
            </v-col>

            <v-col cols="12" class="col-md-6" :class="colclass">
              <v-col :class="radiocolclass">
                <v-radio-group
                  v-model="gender"
                  row
                  :rules="[
                    rules.required('baseGender'),
                    rules.maxlength('baseGender'),
                  ]"
                  :readonly="isReadonly"
                  hide-details="auto"
                  @change="save"
                >
                  <span class="col-4 py-0">{{ itemLabel('baseGender') }}</span>
                  <i-radio
                    label="남"
                    value="남"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                  <i-radio
                    label="여"
                    value="여"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                </v-radio-group>
              </v-col>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="col-md-6" :class="colclass">
              <i-text-field
                :label="itemLabel('baseNameEn')"
                v-model="nameEn"
                v-maxlength="'base_name_en'"
                outlined
                hide-details="auto"
                dense
                :readonly="isReadonly"
                :rules="[
                  rules.required('baseNameEn'),
                  rules.maxlength('baseNameEn'),
                ]"
                @blur="save"
                :class="rightRoundedClass"
              ></i-text-field>
            </v-col>
            <v-col
              cols="12"
              class="col-md-6"
              :class="colclass"
              v-if="useNationality"
            >
              <DirectInputSelect
                :useDirect="opts.baseNationality.oDirectInput == 'Y'"
                :items="opts.baseNationality.oItems.split('#')"
                v-model="nationality"
                :label="itemLabel('baseNationality')"
                v-maxlength="'base_nationality'"
                outlined
                hide-details="auto"
                dense
                :readonly="isReadonly"
                :rules="[rules.required('baseNationality')]"
                @blur="save"
                :class="rightRoundedClass"
              />
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col cols="12" class="col-md-4">
              <CommonDatePicker
                :readonly="isReadonly"
                :label="itemLabel('baseBirthday')"
                v-model="birth"
                useMaxCurrentDate
                @change="save"
                :rules="[rules.required('baseBirthday')]"
              />
            </v-col>
            <v-col
              cols="12"
              class="col-md-4"
              :class="colclass"
              v-if="useNationality"
            >
              <DirectInputSelect
                :useDirect="itemDirectInput('baseNationality')"
                :items="itemArray('baseNationality')"
                v-maxlength="'base_nationality'"
                v-model="nationality"
                :label="itemLabel('baseNationality')"
                outlined
                hide-details="auto"
                dense
                :readonly="isReadonly"
                :rules="[rules.required('baseNationality')]"
                @blur="save"
                :class="rightRoundedClass"
              />
            </v-col>

            <v-col
              cols="12"
              :class="`col-md-${useNationality ? 4 : 6} ${colclass}`"
            >
              <v-col :class="radiocolclass">
                <v-radio-group
                  v-model="gender"
                  row
                  :rules="[
                    rules.required('baseGender'),
                    rules.maxlength('baseGender'),
                  ]"
                  hide-details="auto"
                  :readonly="isReadonly"
                  @change="save"
                >
                  <span class="col-4 py-0">{{ itemLabel('baseGender') }}</span>
                  <i-radio
                    label="남"
                    value="남"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                  <i-radio
                    label="여"
                    value="여"
                    class="col-4 py-0 mr-0"
                  ></i-radio>
                </v-radio-group>
              </v-col>
            </v-col>
          </v-row>
          <v-row v-if="['D', 'C', 'J', 'I'].includes(base)" class="mt-2">
            <v-col cols="12" class="col-md-6" :class="colclass">
              <i-text-field
                :label="itemLabel('baseNameEn')"
                v-model="nameEn"
                v-maxlength="'base_name_en'"
                outlined
                dense
                :rules="[
                  rules.required('baseNameEn'),
                  rules.maxlength('baseNameEn'),
                ]"
                hide-details="auto"
                @blur="save"
                :class="leftRoundedClass"
                :readonly="isReadonly"
              ></i-text-field>
            </v-col>
            <v-col cols="12" class="col-md-6" :class="colclass">
              <i-text-field
                :label="itemLabel('baseNameCh')"
                v-maxlength="'base_name_ch'"
                v-model="nameCh"
                outlined
                dense
                hide-details="auto"
                :rules="[
                  rules.required('baseNameCh'),
                  rules.maxlength('baseNameCh'),
                ]"
                @blur="save"
                :class="rightRoundedClass"
                :readonly="isReadonly"
              ></i-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-if="useAddress">
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12" class="btn-post-wrap col-md-6">
              <i-text-field
                v-model="zip"
                :label="
                  (this.isRequiredItem('baseAddr') ? '*' : '') + '우편번호'
                "
                @click="addrPop = true"
                outlined
                hide-details="auto"
                dense
                :class="leftRoundedClass"
                :rules="[rules.required('baseAddr')]"
                readonly
              ></i-text-field>
              <PopDaumPostCode
                v-model="addrPop"
                v-if="!isReadonly"
                @apply="applyAddress"
              ></PopDaumPostCode>
            </v-col>
            <v-col cols="12" class="col-md-6" :class="colclass">
              <i-text-field
                v-model="address"
                :label="(this.isRequiredItem('baseAddr') ? '*' : '') + `주소`"
                outlined
                @click="addrPop = true"
                dense
                hide-details="auto"
                :rules="[rules.required('baseAddr')]"
                readonly
                :class="rightRoundedClass"
              ></i-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12">
              <i-text-field
                v-model="detailAddress"
                :label="
                  (this.isRequiredItem('baseAddr') ? '*' : '') + '상세주소'
                "
                outlined
                dense
                @click="
                  () => {
                    if (!address) addrPop = true;
                  }
                "
                hide-details="auto"
                @blur="save"
                :rules="[rules.required('baseAddr')]"
                :readonly="isReadonly"
              ></i-text-field>
            </v-col>
          </v-row>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import PopDaumPostCode from '@/components/items/PopDaumPostCode.vue';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { resumeType } from '@/const/resumeType';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
    },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },
  },
  components: { PopDaumPostCode, CommonDatePicker, DirectInputSelect },
  computed: {
    radiocolclass: function() {
      return {
        'mt-n4':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    useAddress() {
      return resumeType.typeBase[this.template?.typeBase]?.includes('baseAddr');
    },
    useNationality() {
      return ['G', 'H', 'I', 'J', 'K', 'L'].includes(this.template?.typeBase);
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    addrPop: false,
    name: '',
    email: '',
    phone: '',
    birth: '',
    gender: '',
    addr: null,
    zip: '',
    address: '',
    detailAddress: '',
    nameEn: '',
    nationality: '',
    nameCh: '',
    delimeter: ' ',
    itemDelimeter: '#',
    base: '',
    alert: false,
  }),
  methods: {
    itemLabel: function(key) {
      return (
        (this.isRequiredItem(key) ? '*' : '') + this.$t(this.template[key])
      );
    },
    isRequiredItem(key) {
      if (!this.opts || !this.opts.hasOwnProperty(key)) return false;
      return this.opts[key]?.oRequireYn == 'Y';
    },
    setting: function() {
      if (this.template.typeBase) this.base = this.template.typeBase;
      this.settingData();
    },
    settingData: function() {
      if (this.info && this.info.base) {
        if (this.info.base.baseBirthday) {
          var date = this.info.base.baseBirthday;
          this.birth =
            date.substring(0, 4) +
            '-' +
            date.substring(4, 6) +
            '-' +
            date.substring(6, 8);
        }

        this.nameEn = this.info.base.baseNameEn
          ? this.info.base.baseNameEn
          : '';
        this.nameCh = this.info.base.baseNameCh
          ? this.info.base.baseNameCh
          : '';
        this.gender = this.info.base.baseGender
          ? this.info.base.baseGender
          : '';
        this.nationality = this.info.base.baseNationality ?? '';

        this.address = this.info.base.baseAddr ? this.info.base.baseAddr : '';
        this.zip = this.info.base.baseZonecode
          ? this.info.base.baseZonecode
          : '';
        this.detailAddress = this.info.base.baseAddrDetail
          ? this.info.base.baseAddrDetail
          : '';

        if (this.info.base.baseAddr) {
          this.addr = {
            address: this.info.base.baseAddr,
            addressEnglish: this.info.base.baseAddrEng,
            apartment: this.info.base.baseApartment,
            bcode: this.info.base.bcode,
            bname: this.info.base.bname,
            bnameEnglish: this.info.base.baseBnameEng,
            bname1: this.info.base.baseBname1,
            bname1English: this.info.base.baseBname1Eng,
            bname2: this.info.base.baseBname2,
            bname2English: this.info.base.baseBname2Eng,
            buildingCode: this.info.base.baseBuildingCode,
            buildingName: this.info.base.baseBuildingName,
            jibunAddress: this.info.base.baseJibunAddr,
            jibunAddressEnglish: this.info.base.baseJibunAddrEng,
            roadAddress: this.info.base.baseRoadAddr,
            roadAddressEnglish: this.info.base.roadAddressEnglish,
            roadname: this.info.base.roadname,
            roadnameCode: this.info.base.roadnameCode,
            roadnameEnglish: this.info.base.roadnameEnglish,
            sido: this.info.base.baseSido,
            sidoEnglish: this.info.base.baseSidoEng,
            sigungu: this.info.base.baseSigungu,
            sigunguEnglish: this.info.base.baseSigunguEng,
            zonecode: this.info.base.baseZonecode,
          };
        }
      }
    },

    calcAge: function(birth = '') {
      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      birth = birth.replace(pattern, '');
      if (!birth) return null;

      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      month = String(month).padStart(2, '0');
      day = String(day).padStart(2, '0');
      var monthday = month + day;

      var birthY = birth.substring(0, 4);
      var birthMD = birth.substring(4, 8);
      const result =
        monthday < birthMD ? year - Number(birthY) - 1 : year - Number(birthY);

      return result >= 0 && result <= 100 ? result : null;
    },
    applyAddress: function(addrInfo) {
      this.addr = addrInfo;
      this.zip = addrInfo.zonecode;
      this.address = addrInfo.address;
      this.detailAddress = '';

      this.save();
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function() {
      const id = {
        annoId: this.$route.params.annoId,
      };
      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      var date = this.birth.replace(pattern, '');

      const p = {
        id: id,
        baseHname: this.name,
        baseGender: this.gender,
        baseAge: this.calcAge(date),
        baseBirthday: date,
        baseNameCh: this.nameCh,
        baseNameEn: this.nameEn,
        baseNationality: this.nationality,
        baseAddrDetail: this.detailAddress,
      };

      if (this.addr) {
        p['baseAddr'] = this.addr.address;
        p['baseAddrEng'] = this.addr.addressEnglish;
        p['baseApartment'] = this.addr.apartment;
        p['baseBcode'] = this.addr.bcode;
        p['baseBname'] = this.addr.bname;
        p['baseBnameEng'] = this.addr.bnameEnglish;
        p['baseBname1'] = this.addr.bname1;
        p['baseBname1Eng'] = this.addr.bname1English;
        p['baseBname2'] = this.addr.bname2;
        p['baseBname2Eng'] = this.addr.bname2English;
        p['baseBuildingCode'] = this.addr.buildingCode;
        p['baseBuildingName'] = this.addr.buildingName;
        p['baseJibunAddr'] = this.addr.jibunAddress;
        p['baseJibunAddrEng'] = this.addr.jibunAddressEnglish;
        p['baseRoadAddr'] = this.addr.roadAddress;
        p['baseRoadAddrEng'] = this.addr.roadAddressEnglish;
        p['baseRoadname'] = this.addr.roadname;
        p['baseRoadnameCode'] = this.addr.roadnameCode;
        p['baseRoadnameEng'] = this.addr.roadnameEnglish;
        p['baseSido'] = this.addr.sido;
        p['baseSidoEng'] = this.addr.sidoEnglish;
        p['baseSigungu'] = this.addr.sigungu;
        p['baseSigunguEng'] = this.addr.sigunguEnglish;
        p['baseZonecode'] = this.addr.zonecode;
      }

      this.$emit('save', p, 'base');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('BASE SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
